import { FullContainer } from '@gorila-shared-ui/components';
import { Tab, Tabs } from 'baseui/tabs-motion';
import { useState } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { AlarmsDownloadsTab } from '../downloads/AlarmsDownloadsTab';
import { ConsumptionDownloadsTab } from '../downloads/ConsumptionDownloadsTab';
import DoorStateDownloadsTab from '../downloads/DoorStateDownloadsTab';
import { EvidencesDownloadsTab } from '../downloads/EvidencesDownloadsTab';
import { PathsDownloadsTab } from '../downloads/PathsDownloadsTab';
import { PositionDownloadsTab } from '../downloads/PositionDownloadsTab';
import { TelemetryDownloadsTab } from '../downloads/TelemetryDownloadsTab';

export function DownloadsPage() {
  const {
    overrides: { tabOverrides, tabsOverrides },
  } = useStyles();
  const [activeKey, setActiveKey] = useState(0);

  return (
    <FullContainer verticalFlex>
      <Tabs
        activeKey={activeKey}
        onChange={({ activeKey }) => {
          setActiveKey(activeKey as number);
        }}
        activateOnFocus
        overrides={tabsOverrides}
      >
        <Tab
          title="Actividad de conducción"
          overrides={tabOverrides}
        >
          <PositionDownloadsTab />
        </Tab>
        <Tab
          title="Historial de viajes"
          overrides={tabOverrides}
        >
          <PathsDownloadsTab />
        </Tab>
        <Tab
          title="Alarmas"
          overrides={tabOverrides}
        >
          <AlarmsDownloadsTab />
        </Tab>
        <Tab
          title="Historial de evidencias"
          overrides={tabOverrides}
        >
          <EvidencesDownloadsTab />
        </Tab>
        <Tab
          title="Telemetría"
          overrides={tabOverrides}
        >
          <TelemetryDownloadsTab />
        </Tab>
        <Tab
          title="Consumo media"
          overrides={tabOverrides}
        >
          <ConsumptionDownloadsTab />
        </Tab>
        <Tab
          title="Apertura / Cierre de puerta"
          overrides={tabOverrides}
        >
          <DoorStateDownloadsTab />
        </Tab>
      </Tabs>
    </FullContainer>
  );
}
